<script>
    import { t } from "../../../i18n";
</script>

<div class="tab-pane pl-0" id="activity" aria-labelledby="activity-tab" role="tabpanel">
    <div class="card-body">
        <ul class="widget-timeline mb-0">


            <li class="timeline-items timeline-icon-primary active">
                <div class="timeline-time">2022-06-10 10:42</div>
                <h6 class="timeline-title">{$t('files.creation')}</h6>
                <p class="timeline-text">Mockup.psd was created</p>
                <div class="timeline-content">
                    <img src="assets/theme/images/icon/psd.png" alt="PSD" height="30" width="25" class="mr-50">Mockup.psd
                </div>
            </li>


            <!--
            <li class="timeline-items timeline-icon-success active">
                <div class="timeline-time">Today</div>
                <h6 class="timeline-title">You added an item to</h6>
                <p class="timeline-text">You added an item</p>
                <div class="timeline-content">
                    <img src="assets/theme/images/icon/psd.png" alt="PSD" height="30" width="25" class="mr-50">Mockup.psd
                </div>
            </li>
            <li class="timeline-items timeline-icon-info active">
                <div class="timeline-time">10 min ago</div>
                <h6 class="timeline-title">You shared 2 times</h6>
                <p class="timeline-text">Emily Bennett edited an item</p>
                <div class="timeline-content">
                    <img src="assets/theme/images/icon/sketch.png" alt="Sketch" height="30" width="25" class="mr-50">Template_Design.sketch
                </div>
            </li>
            <li class="timeline-items timeline-icon-danger active">
                <div class="timeline-time">Mon 10:20 PM</div>
                <h6 class="timeline-title">You edited an item</h6>
                <p class="timeline-text">You edited an item</p>
                <div class="timeline-content">
                    <img src="assets/theme/images/icon/pdf.png" alt="document" height="30" width="25" class="mr-50">Information.doc
                </div>
            </li>
            <li class="timeline-items timeline-icon-primary active">
                <div class="timeline-time">Jul 13 2019</div>
                <h6 class="timeline-title">You edited an item</h6>
                <p class="timeline-text">John Keller edited an item</p>
                <div class="timeline-content">
                    <img src="assets/theme/images/icon/pdf.png" alt="document" height="30" width="25" class="mr-50">Documentation.doc
                </div>
            </li>
            <li class="timeline-items timeline-icon-warning">
                <div class="timeline-time">Apr 18 2019</div>
                <h6 class="timeline-title">You added an item to</h6>
                <p class="timeline-text">You edited an item</p>
                <div class="timeline-content">
                    <img src="assets/theme/images/icon/pdf.png" alt="document" height="30" width="25" class="mr-50">Resume.pdf
                </div>
            </li>
            -->
        </ul>
    </div>
</div>